import React from 'react';
import ReactDOM from 'react-dom';
import {withRouter} from 'react-router';
import App from './App';
import {BrowserRouter} from "react-router-dom";

const Appr = withRouter(App);

ReactDOM.render(
  <BrowserRouter>
    <Appr/>
  </BrowserRouter>

  , document.getElementById('root'));

